import { render } from "./ChatLoading.vue?vue&type=template&id=0033e010&scoped=true"
import script from "./ChatLoading.vue?vue&type=script&lang=ts"
export * from "./ChatLoading.vue?vue&type=script&lang=ts"

import "./ChatLoading.vue?vue&type=style&index=0&id=0033e010&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-0033e010"

export default script